import * as yup from 'yup';

export const DataSourceSchema = yup.object({
    fileId: yup.number(),
    sheetId: yup.number(),
});
